import { boolean, mixed, object, string } from "yup";

export const DEFAULT_VALUES = {
  type: "",
  hasParent: false,
  autoGenerateCode: false,
  code: "",
  name: "",
  isActive: true,
};

export const VALIDATION_SCHEMA = object().shape({
  type: string().required("Harus diisi"),
  hasParent: boolean().required(),
  parentChartOfAccount: mixed().when("hasParent", {
    is: true,
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.nullable(),
  }),
  autoGenerateCode: boolean().required(),
  code: string().when("autoGenerateCode", {
    is: false,
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),
  name: string().required("Harus diisi"),
  isActive: boolean().required(),
});
